<template>
    <el-dialog title="[Comarch]Soumettre à validation" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Soumettre à validation pour Comarch les {{ items_selected }} produits selectionnés</div>
        <el-form class="formSynchronize" ref="form" :model="form">

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                direction: null
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        user() {
            return this.$store.getters['app/user'];
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                direction: this.form.direction,
                user_id: this.user.id,
                mode: 'comarch'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Soumettre à validation pour Comarch les produits ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios
                    .post('/products/bulk', datas)
                    .then(r => {
                        this.$refs.form.resetFields();
                        this.display = false;
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loader = false;
                    });
                }).catch(()=>{

                })

        }
    }
};
</script>
